import React from 'react';

export default function ClipIcon({ active = false, size = 22, ...props }) {
  const stroke = active ? 'rgba(255,215,0,0.9)' : 'rgba(255,215,0,0.6)';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Scissors: two finger loops and crossed blades */}
      <circle cx="6" cy="6" r="3" stroke={stroke} strokeWidth="1.6" />
      <circle cx="6" cy="18" r="3" stroke={stroke} strokeWidth="1.6" />
      <path d="M20 4 8.12 15.88" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.47 14.48 20 20" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.12 8.12 12 12" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
